webpackJsonp([1],{

/***/ 204:
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),

/***/ 205:
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

(function(a,b){ true?module.exports=b(__webpack_require__(209),__webpack_require__(210),__webpack_require__(212),__webpack_require__(213),__webpack_require__(214),__webpack_require__(216),__webpack_require__(205),__webpack_require__(217),__webpack_require__(204),__webpack_require__(0),__webpack_require__(1)):"function"==typeof define&&define.amd?define(["@babel/runtime/helpers/objectSpread","@babel/runtime/helpers/objectWithoutProperties","@babel/runtime/helpers/classCallCheck","@babel/runtime/helpers/createClass","@babel/runtime/helpers/possibleConstructorReturn","@babel/runtime/helpers/getPrototypeOf","@babel/runtime/helpers/assertThisInitialized","@babel/runtime/helpers/inherits","@babel/runtime/helpers/defineProperty","react","prop-types"],b):(a=a||self,a.Img=b(a._objectSpread,a._objectWithoutProperties,a._classCallCheck,a._createClass,a._possibleConstructorReturn,a._getPrototypeOf,a._assertThisInitialized,a._inherits,a._defineProperty,a.React,a.propTypes))})(this,function(a,b,c,d,e,f,g,h,j,k,l){'use strict';a=a&&a.hasOwnProperty("default")?a["default"]:a,b=b&&b.hasOwnProperty("default")?b["default"]:b,c=c&&c.hasOwnProperty("default")?c["default"]:c,d=d&&d.hasOwnProperty("default")?d["default"]:d,e=e&&e.hasOwnProperty("default")?e["default"]:e,f=f&&f.hasOwnProperty("default")?f["default"]:f,g=g&&g.hasOwnProperty("default")?g["default"]:g,h=h&&h.hasOwnProperty("default")?h["default"]:h,j=j&&j.hasOwnProperty("default")?j["default"]:j;var m="default"in k?k["default"]:k,n={},o={loader:l.node,unloader:l.node,decode:l.bool,crossorigin:l.string,src:l.oneOfType([l.string,l.array]),container:l.func,loaderContainer:l.func,unloaderContainer:l.func},p=function(i){function k(a){var b;c(this,k),b=e(this,f(k).call(this,a)),j(g(b),"srcToArray",function(a){return(Array.isArray(a)?a:[a]).filter(function(a){return a})}),j(g(b),"onLoad",function(){n[b.sourceList[b.state.currentIndex]]=!0,b.i&&b.setState({isLoaded:!0})}),j(g(b),"onError",function(){if(n[b.sourceList[b.state.currentIndex]]=!1,!b.i)return!1;for(var a,c=b.state.currentIndex+1;c<b.sourceList.length;c++){if(a=b.sourceList[c],!(a in n)){b.setState({currentIndex:c});break}if(!0===n[a])return b.setState({currentIndex:c,isLoading:!1,isLoaded:!0}),!0;!1===n[a]}return c===b.sourceList.length?b.setState({isLoading:!1}):void b.loadImg()}),j(g(b),"loadImg",function(){b.i=new Image,b.i.src=b.sourceList[b.state.currentIndex],b.props.crossorigin&&(b.i.crossorigin=b.props.crossorigin),b.props.decode&&b.i.decode?b.i.decode().then(b.onLoad)["catch"](b.onError):(b.i.onload=b.onLoad,b.i.onerror=b.onError)}),j(g(b),"unloadImg",function(){b.i.onerror=null,b.i.onload=null,b.i.src="";try{delete b.i.src}catch(a){}delete b.i}),b.loaderContainer=a.loaderContainer||a.container,b.unloaderContainer=a.unloaderContainer||a.container,b.sourceList=b.srcToArray(b.props.src);for(var d=0;d<b.sourceList.length&&!!(b.sourceList[d]in n);d++)if(!0===n[b.sourceList[d]])return b.state={currentIndex:d,isLoading:!1,isLoaded:!0},e(b);return b.state=b.sourceList.length?{currentIndex:0,isLoading:!0,isLoaded:!1}:{isLoading:!1,isLoaded:!1},b}return h(k,i),d(k,[{key:"componentDidMount",value:function(){this.state.isLoading&&this.loadImg()}},{key:"componentWillUnmount",value:function(){this.i&&this.unloadImg()}},{key:"componentWillReceiveProps",value:function(a){var b=this;this.loaderContainer=a.loaderContainer||a.container,this.unloaderContainer=a.unloaderContainer||a.container;var c=this.srcToArray(a.src),d=c.filter(function(a){return-1===b.sourceList.indexOf(a)}),e=this.sourceList.filter(function(a){return-1===c.indexOf(a)});if(d.length||e.length){if(this.sourceList=c,!c.length)return this.setState({isLoading:!1,isLoaded:!1});this.setState({currentIndex:0,isLoading:!0,isLoaded:!1},this.loadImg)}}},{key:"render",value:function(){var c=this.props,d=c.container,e=c.loader,f=c.unloader,g=c.src,h=c.crossorigin,i=c.decode,j=c.loaderContainer,k=c.unloaderContainer,l=c.mockImage,n=b(c,["container","loader","unloader","src","crossorigin","decode","loaderContainer","unloaderContainer","mockImage"]);if(this.state.isLoaded){var o=a({},{src:this.sourceList[this.state.currentIndex]},n);return d(m.createElement("img",o))}return!this.state.isLoaded&&this.state.isLoading?e?this.loaderContainer(e):null:this.state.isLoaded||this.state.isLoading?void 0:f?this.unloaderContainer(f):null}}]),k}(k.Component);return j(p,"defaultProps",{loader:!1,unloader:!1,decode:!0,src:[],container:function(a){return a}}),p.propTypes={},p});
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(204);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

module.exports = _objectSpread;

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(211);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),

/***/ 211:
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),

/***/ 212:
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),

/***/ 213:
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(215);

var assertThisInitialized = __webpack_require__(205);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),

/***/ 215:
/***/ (function(module, exports) {

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),

/***/ 216:
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(218);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),

/***/ 218:
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactImage = __webpack_require__(208);

var _reactImage2 = _interopRequireDefault(_reactImage);

var _images = __webpack_require__(268);

var _images2 = _interopRequireDefault(_images);

var _images3 = __webpack_require__(269);

var _images4 = _interopRequireDefault(_images3);

var _images5 = __webpack_require__(270);

var _images6 = _interopRequireDefault(_images5);

var _images7 = __webpack_require__(271);

var _images8 = _interopRequireDefault(_images7);

var _images9 = __webpack_require__(272);

var _images10 = _interopRequireDefault(_images9);

var _images11 = __webpack_require__(273);

var _images12 = _interopRequireDefault(_images11);

var _images13 = __webpack_require__(274);

var _images14 = _interopRequireDefault(_images13);

var _images15 = __webpack_require__(275);

var _images16 = _interopRequireDefault(_images15);

var _images17 = __webpack_require__(276);

var _images18 = _interopRequireDefault(_images17);

var _images19 = __webpack_require__(277);

var _images20 = _interopRequireDefault(_images19);

var _images21 = __webpack_require__(278);

var _images22 = _interopRequireDefault(_images21);

var _images23 = __webpack_require__(279);

var _images24 = _interopRequireDefault(_images23);

var _images25 = __webpack_require__(280);

var _images26 = _interopRequireDefault(_images25);

var _images27 = __webpack_require__(281);

var _images28 = _interopRequireDefault(_images27);

var _images29 = __webpack_require__(282);

var _images30 = _interopRequireDefault(_images29);

var _images31 = __webpack_require__(283);

var _images32 = _interopRequireDefault(_images31);

var _images33 = __webpack_require__(284);

var _images34 = _interopRequireDefault(_images33);

var _images35 = __webpack_require__(285);

var _images36 = _interopRequireDefault(_images35);

var _images37 = __webpack_require__(286);

var _images38 = _interopRequireDefault(_images37);

var _images39 = __webpack_require__(287);

var _images40 = _interopRequireDefault(_images39);

var _images41 = __webpack_require__(288);

var _images42 = _interopRequireDefault(_images41);

var _images43 = __webpack_require__(289);

var _images44 = _interopRequireDefault(_images43);

var _images45 = __webpack_require__(290);

var _images46 = _interopRequireDefault(_images45);

var _images47 = __webpack_require__(291);

var _images48 = _interopRequireDefault(_images47);

var _images49 = __webpack_require__(292);

var _images50 = _interopRequireDefault(_images49);

var _images51 = __webpack_require__(293);

var _images52 = _interopRequireDefault(_images51);

var _images53 = __webpack_require__(294);

var _images54 = _interopRequireDefault(_images53);

var _images55 = __webpack_require__(295);

var _images56 = _interopRequireDefault(_images55);

var _images57 = __webpack_require__(296);

var _images58 = _interopRequireDefault(_images57);

var _images59 = __webpack_require__(297);

var _images60 = _interopRequireDefault(_images59);

var _images61 = __webpack_require__(298);

var _images62 = _interopRequireDefault(_images61);

var _images63 = __webpack_require__(299);

var _images64 = _interopRequireDefault(_images63);

var _images65 = __webpack_require__(300);

var _images66 = _interopRequireDefault(_images65);

var _images67 = __webpack_require__(301);

var _images68 = _interopRequireDefault(_images67);

var _images69 = __webpack_require__(302);

var _images70 = _interopRequireDefault(_images69);

var _images71 = __webpack_require__(303);

var _images72 = _interopRequireDefault(_images71);

var _images73 = __webpack_require__(304);

var _images74 = _interopRequireDefault(_images73);

var _images75 = __webpack_require__(305);

var _images76 = _interopRequireDefault(_images75);

var _images77 = __webpack_require__(306);

var _images78 = _interopRequireDefault(_images77);

var _images79 = __webpack_require__(307);

var _images80 = _interopRequireDefault(_images79);

var _images81 = __webpack_require__(308);

var _images82 = _interopRequireDefault(_images81);

var _images83 = __webpack_require__(309);

var _images84 = _interopRequireDefault(_images83);

var _images85 = __webpack_require__(310);

var _images86 = _interopRequireDefault(_images85);

var _images87 = __webpack_require__(311);

var _images88 = _interopRequireDefault(_images87);

var _images89 = __webpack_require__(312);

var _images90 = _interopRequireDefault(_images89);

var _images91 = __webpack_require__(313);

var _images92 = _interopRequireDefault(_images91);

var _images93 = __webpack_require__(314);

var _images94 = _interopRequireDefault(_images93);

var _images95 = __webpack_require__(315);

var _images96 = _interopRequireDefault(_images95);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RandomImages = function (_React$Component) {
  _inherits(RandomImages, _React$Component);

  function RandomImages() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RandomImages);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RandomImages.__proto__ || Object.getPrototypeOf(RandomImages)).call.apply(_ref, [this].concat(args))), _this), _this.images = [_images2.default, _images4.default, _images6.default, _images8.default, _images10.default, _images12.default, _images14.default, _images16.default, _images18.default, _images20.default, _images22.default, _images24.default, _images26.default, _images28.default, _images30.default, _images32.default, _images34.default, _images36.default, _images38.default, _images40.default, _images42.default, _images44.default, _images46.default, _images48.default, _images50.default, _images52.default, _images54.default, _images56.default, _images58.default, _images60.default, _images62.default, _images64.default, _images66.default, _images68.default, _images70.default, _images72.default, _images74.default, _images76.default, _images78.default, _images80.default, _images82.default, _images84.default, _images86.default, _images88.default, _images90.default, _images92.default, _images94.default, _images96.default], _this.state = {
      visibleImages: []
    }, _this.handleClick = function (e) {
      var _e$nativeEvent = e.nativeEvent,
          x = _e$nativeEvent.x,
          y = _e$nativeEvent.y;

      if (_this.images.length === 0) {
        _this.refill();
      }

      _this.setState(function (prevState) {
        return {
          visibleImages: [].concat(_toConsumableArray(prevState.visibleImages), [{
            x: x,
            y: y,
            src: _this.images.splice(Math.random() * _this.images.length, 1)[0]
          }])
        };
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RandomImages, [{
    key: "refill",
    value: function refill() {
      this.images = [_images2.default, _images4.default, _images6.default, _images6.default, _images10.default, _images12.default, _images14.default, _images16.default, _images20.default, _images28.default, _images30.default, _images32.default, _images34.default, _images36.default, _images38.default, _images40.default, _images42.default, _images44.default, _images48.default, _images50.default, _images52.default, _images54.default, _images56.default, _images58.default, _images60.default, _images62.default, _images64.default, _images66.default, _images68.default, _images70.default, _images72.default, _images74.default, _images76.default, _images78.default, _images80.default, _images82.default, _images84.default, _images86.default, _images88.default, _images90.default, _images92.default, _images94.default, _images96.default];
      this.images.forEach(function (image, i, images) {
        var img = new Image();
        img.src = image;
        images[i] = img.src;
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.images.forEach(function (image, i, images) {
        var img = new Image();
        img.src = image;
        images[i] = img.src;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var visibleImages = this.state.visibleImages;

      return _react2.default.createElement(
        "div",
        { className: "about-wrapper", onClick: function onClick(e) {
            return _this2.handleClick(e);
          } },
        this.props.children,
        visibleImages.map(function (_ref2, i) {
          var x = _ref2.x,
              y = _ref2.y,
              src = _ref2.src;
          return _react2.default.createElement(_reactImage2.default, {
            className: "about-image",
            key: i,
            style: { top: y + "px", left: x + "px" },
            src: "" + src
          });
        })
      );
    }
  }]);

  return RandomImages;
}(_react2.default.Component);

exports.default = RandomImages;

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00001.547da19f.png";

/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00002.3a5ab554.png";

/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00003.0e9ab002.png";

/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00004.6d6284de.png";

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00005.bed2fbaf.png";

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00006.cc279e6f.png";

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00007.19303e53.jpg";

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00008.a230c676.jpg";

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00009.aa1ac311.jpg";

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00010.77357726.png";

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00011.9008335b.jpg";

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00012.17bb9b8c.jpg";

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00013.a1d42e95.png";

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00014.497ddf02.png";

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00015.7b031268.png";

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00016.bcf3a207.png";

/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00017.32cd8ca9.png";

/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00018.955ea92e.png";

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00019.1e26486b.png";

/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00020.6a8bab05.png";

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00021.5f399533.png";

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00022.d8ff93e7.png";

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00023.b48bca19.png";

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00024.f06d4d44.jpg";

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00025.e26a045f.jpg";

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00026.a3f86577.jpg";

/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00027.32983474.jpg";

/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00028.01109944.jpg";

/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00029.52e5ce91.jpg";

/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00030.091aa716.jpg";

/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00031.13cabcb5.jpg";

/***/ }),

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00032.4dca1919.jpg";

/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00033.0517780d.jpg";

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00034.6e21395c.jpg";

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00035.1090f255.jpg";

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00036.b7c2f0f0.jpg";

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00037.f8782b08.jpg";

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00038.f79b1028.jpg";

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00039.7022e3a2.jpg";

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00040.f67cad86.jpg";

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00041.e0132ded.jpg";

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00042.4b11a9cb.jpg";

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00043.dd8e500c.jpg";

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00044.8adcddf6.png";

/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00045.c86c101f.png";

/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00046.70474144.png";

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00047.71d65de0.png";

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images00048.077f4b51.png";

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(34);

var _randomimage = __webpack_require__(267);

var _randomimage2 = _interopRequireDefault(_randomimage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      _randomimage2.default,
      null,
      _react2.default.createElement(
        "h1",
        { className: "about" },
        _react2.default.createElement(
          "span",
          null,
          "soju.studio is a Vienna-based team of young, multidisciplinary creatives with a focus on graphic design, photography and visual design in both, traditional and digital media.",
          " "
        ),
        _react2.default.createElement("br", null),
        _react2.default.createElement(
          "span",
          null,
          "Feel free to ",
          _react2.default.createElement(
            _reactStatic.Link,
            { to: "/contact" },
            "contact us"
          ),
          " for freelance work or collaborations."
        ),
        _react2.default.createElement("br", null)
      )
    )
  );
};

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/About.a8953faa.js